<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>医院列表</a></p>
            </div>
        </div>
        <div class="content">
            <div class="bannerImg">
                <div class="DocTopImgRT" > 
                    <div style="font-weight: bold;font-size: 16px;color: #FEFEFE;margin-right:120px">
                        <i class="el-icon-location"></i>
                        <span>{{cityName}}</span>
                    </div>
                    <div class="DocTopImgRT" style="font-size: 16px;color: #FEFEFE;">
                        <span style="margin-right:35px">
                            <i class="el-icon-circle-check" ></i>
                            <span style="margin-left:5px">海量医生</span>
                        </span>
                        <span style="margin-right:35px">
                            <i class="el-icon-circle-check" ></i>
                            <span style="margin-left:5px">专业服务</span>
                        </span>
                        <span>
                            <i class="el-icon-circle-check" ></i>
                            <span style="margin-left:5px">安全可信赖</span>
                        </span>
                    </div>
                </div>
                <div style="margin-top:10px;width:850px;position: relative;" >
                    <el-input placeholder="输入医院搜索..." v-model="hosKeyWord" class="inputSearch">
                        
                    </el-input>
                    <el-button class="searchBtn" @click="goSearch">搜索</el-button>
                </div>
            </div>
        </div>
        <div class="contentRes"> 
            <div class="contentList">
                <div style="margin: 20px 30px;">
                    <div class="contentListTop" style="margin-bottom:10px" >
                        <div class="contentListLine"></div><span>按医院挂号</span> <span style="margin-left:10px;color: #666666;font-size: 16px;">共{{isSearch ? hosListResult.length : hosList.length}}家医院</span>
                    </div>
                    <div class="contentListTop3" style="margin-bottom:20px;position: relative;" @click="selectPostClick">
                        <div :class="setTab == 1 ? 'filterBoxCheck' : ''" @click.stop="selectPost(1)" style="margin-right:50px">
                            <span class="searchNameTitle" style="width: 150px;">综合排序<i class="el-icon-arrow-down" style="margin-left: 5px;"></i></span>
                        </div>
                        <div :class="setTab == 2 ? 'filterBoxCheck' : '' " @click.stop="selectPost(2)" style="margin-right:50px">
                            <span class="searchNameTitle" style="width: 150px;">距离<i class="el-icon-arrow-down" style="margin-left: 5px;"></i></span>
                        </div>
                        <div :class="setTab == 3 ? 'filterBoxCheck' : '' " @click.stop="selectPost(3)">
                            <span>筛选</span>
                            <i class="el-icon-s-operation" style="margin-left: 5px;"></i>
                        </div>
                        <div class="allDiseaseBox" v-if="setTabFalse" ref="mainShowBox">
                            <div class="" v-if="setTab == 3" style="margin-bottom: 50px;">
                                <div style=" display: flex;">
                                    <div style="margin-top:5px;width:120px">医院等级：</div>
                                    <div class="SelectTagBox">
                                        <div  v-for="(item,index) in hoslevList" :key="index" :class="levIndex == index ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goLevIndex(item,index)">
                                            {{item.name}}
                                        </div>
                                    </div>
                                </div>
                                <div style=" display: flex;margin-top:10px">
                                    <div style="width:120px;margin-top:5px">医院性质: </div>
                                     <div class="SelectTagBox">
                                        <div :class="natureType == 1 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goNatureType(1)">
                                           公立医院
                                        </div>
                                         <div :class="natureType == 0 ? 'SelectTagCheck' : 'SelectTag' " @click.stop="goNatureType(0)">
                                           私立医院
                                        </div>
                                    </div>
                                </div>
                                <div style=" display: flex;margin-top:10px">
                                    <div style="margin-top:5px;width:120px">医院类型: </div>
                                    <div class="SelectTagBox">
                                        <div  v-for="(item,index) in hosCatList" :key="index" :class="hosCatIndex == index ? 'SelectTagCheck' : 'SelectTag' " @click.stop="gohosType(item,index)">
                                            {{item.name}}
                                        </div>
                                    </div>
                                </div>
                                <div class="resetBtnBoxBot">
                                    <div class='resetBtnBox' @click.stop="setSearchType">重置</div>
                                    <div  class='sureBtnBox' @click.stop="goSearchType">确定</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="isSearch">
                        <div  class="contentListDoc" v-for="(item,index) in hosListResult" :key="index">
                            <div class="contentListDocTop">
                                <div class="DocTopImg">
                                    <img v-if="item.logoFile" :src="http + item.logoFile" alt="" srcset="">
                                    <img v-else src="../../assets/img/reservation/touxiang03.png" alt="" srcset="">
                                </div>
                                <div class="DocTopImgR">
                                    <div class="DocTopImgRT">
                                        <span class="DocTopImgName">{{item.name}}</span> 
                                    </div>
                                    <div class="DocTopImgRT">
                                        <div class="DocTopTagZ" v-if="item.levelName">{{item.levelName}}</div> 
                                        <div class="DocTopTagZLev" v-if="item.specialtyTypeName">{{item.specialtyTypeName}}</div>
                                        <div class="DocTopTagZLev">{{item.natureType == 0 ? '私立医院' : '公立医院'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div style=" display: flex;align-items: center;justify-content: space-between;">
                                <div class="DocTopImgRT" style="margin-top:15px">
                                    <i class="el-icon-location-outline"></i>
                                    <span style="margin-left:5px">{{item.regionFullName ? item.regionFullName : '暂无地址'}}</span>
                                </div>
                                <div class="" style="width: 20%;text-align: right;">
                                    {{item.distance.toString().split('.')[0] + 'km'}}
                                </div>
                            </div>
                

                            <div class='btnGreen' @click="goHosDetail(item,index)">查看详情</div>
                        </div>
                        <div v-if="hosListResult.length == 0" style="margin-top:70px; display: flex;align-items: center;flex-direction: column;">
                            <img src="../../assets/img/consultation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                            <span style="color: #666666;">暂未找到符合条件的医院！</span>
                        </div>
                    </div>
                    <div v-else>
                        <div  class="contentListDoc" v-for="(item,index) in hosList" :key="index">
                            <div class="contentListDocTop">
                                <div class="DocTopImg">
                                    <img v-if="item.logoFile" :src="http + item.logoFile" alt="" srcset="">
                                    <img v-else src="../../assets/img/reservation/shop01.png" alt="" srcset="">
                                    <!-- <img :src="item.logoFile ? http + item.logoFile : '../../assets/img/reservation/touxiang03.png'" alt="" srcset=""> -->
                                </div>
                                <div class="DocTopImgR">
                                    <div class="DocTopImgRT">
                                        <span class="DocTopImgName">{{item.name}}</span> 
                                    </div>
                                    <div class="DocTopImgRT">
                                        <div class="DocTopTagZ" v-if="item.levelName">{{item.levelName}}</div> 
                                        <div class="DocTopTagZLev" v-if="item.specialtyTypeName">{{item.specialtyTypeName}}</div>
                                        <div class="DocTopTagZLev">{{item.natureType == 0 ? '私立医院' : '公立医院'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div style=" display: flex;align-items: center;justify-content: space-between;">
                                <div class="DocTopImgRT" style="margin-top:15px">
                                    <i class="el-icon-location-outline"></i>
                                    <span style="margin-left:5px">{{item.regionFullName ? item.regionFullName : '暂无地址'}}</span>
                                </div>
                                <div class="" style="width: 20%;text-align: right;">
                                    {{item.distance.toString().split('.')[0] + 'km'}}
                                </div>
                            </div>
                            <div class='btnGreen' @click="goHosDetail(item,index)">查看详情</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="">
                <div class="contentListRight" style="height:120px" v-if="StuDataList.length > 0">
                    <el-carousel trigger="click" height="120px">
                        <el-carousel-item v-for="(item,index) in StuDataList" :key="index" >
                            <img :src="http + item.logoUrl" mode="" style="height: 120px; width: 100%;border-radius: 10px;"  @click="goDetail(item)" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="contentListRight">
                    <div style="margin: 19px 31px 28px 23px;padding-top:20px">
                        <div class="contentListTopR">
                            <div class="contentListLineR"></div><span>温馨提示</span>
                        </div>
                        <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                            本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ft-com></ft-com>
    </div>
</template>

<script>
import myBMap from "../../utils/myBmap";
import { reservationMain } from "../../components/reservation/reservation";
import { consultationMain } from "../../components/consultation/consultation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
const jsonFileData = require('./hosData.json');
export default {
    components: {
        hdCom,
        ftCom,
    },
    data() {
        var reservationMainItem = new reservationMain(this.TokenClient, this.Services.Authorization);
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        return {
            reservationDomain: reservationMainItem,
            consultationDomain: consultationMainItem,
            fontSize: "",
            isSearch:false,
            hosList:[],
            hosListResult:[],
            hoslevList:[],
            hosCatList:jsonFileData,
            levIndex:-1,
            levName:'',
            setTabFalse:false,
            isKmSort:false,
            hosCatIndex:-1,
            hosCatName:'',
            natureName:'',
            http:'',
            hosKeyWord:'',
            setTab:1,
            natureType:-1,
            geolocationOptions:{
                enableHighAccuracy: false,    // 高精度模式
                timeout: 5000,              // 15秒超时
                maximumAge: 600000           // 5分钟缓存有效
            },
            cityName:'暂未',
            lat:'',
            lng:'',
            StuDataList:[]
        }
    },
    mounted() {
       this.gainLocation();
       this.DocProductLevelData()
        this.GetStuDataListData()
       this.http = this.Services.ossUpload;
       document.addEventListener("click", this.selectPostClick);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.selectPostClick);
    },
    methods: {
        goDetail(e){
            this.$router.push({
                path: "./studioListDetail",
                query:{
                    id:e.id
                }
            });
        },
        GetStuDataListData(){
            var _this = this;
            _this.consultationDomain.GetAppletStudioGroupListStu('0','1','1',function (data) {
                 _this.StuDataList = data.data
            },
            function (error) {
                 _this.StuDataList = []
                console.log('', error)
            })
        },
        gainLocation(){
            var _this = this
             myBMap.init().then(() => {
                let geolocation = new BMap.Geolocation();
                geolocation.getCurrentPosition(function (e) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                let point = new BMap.Point(e.point.lng, e.point.lat);
                let gc = new BMap.Geocoder();
                gc.getLocation(point, function (rs) {
                    console.log(rs)
                    if (!rs) {
                        _this.GetOrgListData()
                        return
                    }
                    _this.cityName = rs ? rs.addressComponents.city : '暂无'
                    _this.lat = rs.point.lat ? rs.point.lat : 0
                    _this.lng = rs.point.lng ? rs.point.lng : 0
                    _this.GetOrgListData()
                });
                } else {
                    _this.lat = 0
                    _this.lng = 0
                    _this.GetOrgListData()
                    console.log("定位失败");
                }
                });
            });
        },
        goisZhSort(){
            this.isZhSort = !this.isZhSort
            this.isKmSort = false
            this.hosKeyWord = ''
            this.isSearch = false
            this.GetOrgListData()
        },
        goisKmSort(){
            this.isKmSort = !this.isKmSort
            if (this.isKmSort) {
                this.isZhSort = false
                this.hosListResult = this.hosList
                this.isSearch = true
                this.hosListResult.sort((a,b)=> a.distance - b.distance)
            } else {
                this.isSearch = false
                this.GetOrgListData()
            }

        },
        setSearchType(){
            this.natureType = -1
            this.natureName = ''
            this.levIndex = -1
            this.levName = ''
            this.hosCatName = ''
            this.hosCatIndex = -1
        },
        goSearchType(){
			console.log(this.levName)
			console.log(this.natureName)
			console.log(this.hosCatName)
            let searhosList = []
            this.isSearch = true
            this.hosList.map((res)=>{
                // 公立私立使用
                res.natureName = res.natureType == 0 ? '公立医院' : '私立医院'
                if (res.levelName.indexOf(this.levName) != -1 && res.natureName.indexOf(this.natureName) != -1 && res.specialtyTypeName.indexOf(this.hosCatName) != -1) {
                    searhosList.push(res)
                }
                
            })
            this.hosListResult = searhosList
            this.setTabFalse = false
        },
        gohosType(e,index){
            this.hosCatIndex = index
            this.hosCatName = e.name
        },
        goLevIndex(e,index){
            this.levIndex = index
            this.levName = e.name
        },
        goNatureType(e){
            this.natureType = e
            if (this.natureType == 0) {
                this.natureName = '公立医院'
            }
            if (this.natureType == 1) {
                this.natureName = '私立医院'
            }
        },
        selectPostClick(e) {
            if (!this.$refs.mainShowBox.contains(e.target) && this.$refs.mainShowBox) {
                this.setTabFalse = false
            }
        },
        selectPost(e){
            this.setTab = e
            if (e == 1) {
                this.goisZhSort()
            }
            if (e == 2) {
                this.goisKmSort()
            }
            if (e == 3 ) {
                 this.setTabFalse = true
            }
        },
        goSearch(){
            let searhosList = []
            this.hosList.map((res)=>{
                if (res.name.indexOf(this.hosKeyWord ) != -1) {
                    searhosList.push(res)
                }
                
            })
            this.isSearch = true
            this.hosListResult = searhosList
        },
        DocProductLevelData() {
            // 写死yunhis  net的 productId == 4
			// 写死yunhis 线上 的 productId == 2
            var _this = this;
            _this.consultationDomain.GetProductLevel('2',function (data) {
                _this.hoslevList = data.data
            },
            function (error) {
                 _this.hoslevList = []
                console.log('', error)
            })
        },
        //详情获取
        GetOrgListData() {
            
            var _this = this;
                //  console.log(_this.cityName)
                //     console.log(_this.lat)
                //     console.log(_this.lng)
            let la = _this.lat ? _this.lat : 0
            let ln = _this.lng ? _this.lng : 0
            // console.log(la)
            //  console.log(ln)
            _this.reservationDomain.GetOrgList(ln,la, function (data) {
                _this.hosList = data.data
                  console.log(data.data)
            },
            function (error) {
                 _this.hosList = []
            })
        },
        goHosDetail(e){
            let params = {
                id:e.id,
                name:e.name,
                specialtyTypeName:e.specialtyTypeName,
                levelName:e.levelName,
                regionFullName:e.regionFullName,
                logoFile:e.logoFile,
                latitude:e.latitude,
                longitude:e.longitude,
                natureType:e.natureType
            }
            this.$router.push({
                path: "/reservation/reservationDoctorList",
                query: {
                    hosDetail: JSON.stringify(params),
                },
            });
        }    
    },

}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.content {
  width: 1200px;
    margin: 0 auto;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.bannerImg {
    /* height: 150px; */
    background: linear-gradient(90deg, #00AFB5, #12C7AC);
    border-radius: 6px;
    padding: 30px ;
    padding-bottom: 40px;
}
.bannerImg img {
    width: 330px;
    height: 120px;
    margin-left: 32px;
    margin-top: 20px;
}
.content-top {
  height: 64px;
  background: #ffffff;
  box-shadow: 2px 0 5px rgba(102, 102, 102, 0.08);
}
.diagnose-tab {
    padding: 20px 30px;
    padding-bottom: 0px;
    cursor: pointer;
    border-radius: 0px 0px 6px 6px;
}
.diagnose-tab span {
  margin-right: 50px;
  color: #808080;
  font-size: 16px;
   padding-bottom: 20px;
}

.diagnose-tab span.active {
  color: #00A8AE;
  border-bottom: 2px solid #00A8AE;
}
.contentList {
    margin-top: 20px;
    background: #FFFFFF;
    width: 800px;

}
.contentListTop {
    display: flex;
    align-items: center;
}
.contentListLine {
    width: 3px;
    height: 20px;
    background: #00AFB5;
    border-radius: 2px;
}
.contentListTop span {
   font-size: 20px;
   margin-left: 10px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
    cursor: pointer;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.contentListDoc {
    background: #F5FAF9;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 10px;
    position: relative;
}
.contentListDocTop {
    display: flex;
    /* align-items: center; */
}
.DocTopImg {
    width: 50px;
    height: 50px;
    position: relative;
}
.DocTopImg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.DocTopTag {
    width: 60px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    color: #FFFFFF;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.DocTopImgR {
    margin-left: 16px;

}
.DocTopImgName {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 7px;
}
.DocTopTagZ {
    width: 40px;
    background: #677AEC;
    border-radius: 3px;
    font-size: 10px;
    padding: 2px 0px ;
    color: #FFFFFF;
    text-align: center;
    margin-right: 5px;
}
.DocTopTagZLev {
    border-radius: 3px;
    border: 1px solid #00AFB5;
    padding: 0 5px ;
    font-size: 12px;
    color: #00AFB5;
    margin-right: 5px;
}
.DocTopImgRT {
    display: flex;
    align-items: center;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexB {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.btnGreen {
    width: 100px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    color: #FFFFFF;
    font-size: 16px;
    text-align: center;
    padding: 5px 0;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}
.inputSearch {
    position: relative;
}
 .inputSearch ::v-deep input{
    background: #F5F5F5 !important;
    /* border-radius: 4px; */
    border: none;
    border-radius: 25px;
    height: 50px;
}
.searchBtn {
    position: absolute;
    top: 6px;
    right: 5px;
    background: #DEF0F0 !important;
    border: none !important;
    border-radius: 25px;
    color: #00A8AE;
}
 /* .inputSearch ::v-deep div{
    position: absolute;
    background: #DEF0F0 !important;
    border: none !important;
    border-radius: 25px;
    color: #00A8AE;
} */
.contentListTop3 {
    display: flex;
    align-items: center;
     cursor: pointer;
}
.filterBoxCheck {
    color: #00AFB5;
}
.allDiseaseBox {
  position: absolute;
  top: 45px;
  left: 40px;
  width: 800px;
  padding: 30px 25px;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
  border: 1px solid #EBEBEB;
  min-height: 160px;
  overflow-y: auto;
  z-index: 999;
  /* position: relative; */
}
.SelectTagBox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    width: 100%;
}
.SelectTagCheck {
    background: #E5F8F8;
    border-radius: 2px;
    font-size: 14px;
    color: #00A8AE;
    border-radius: 2px;
    padding: 5px 10px;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 5px;
}
.SelectTag {
  color: #333333;
  padding: 5px 10px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer;
  margin-bottom: 5px;
}
.resetBtnBox {
    width: 80px;
    background: #E9F2F2;
    border-radius: 4px;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
    color: #00A8AE;
    cursor: pointer;
}
.sureBtnBox {
    width: 80px;
    background: #00AFB5;
    border-radius: 4px;
    text-align: center;
    padding: 5px 0;
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 10px;
     cursor: pointer;
}
.resetBtnBoxBot {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 20px;
    right: 30px;
}
</style>
